export default __webpack_public_path__ + "static/media/Group2830.6d1574e4.png";